import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/auth";
import { PageHeader } from "@/pages/Classes";
import { sanitizeHtml } from "@/lib/sanitize";

export default function LegalPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/pages/${slug}`).then(r => setPage(r.data)).catch(() => setNotFound(true));
  }, [slug]);
  if (notFound) return <div className="pt-40 text-center">
    <h1 className="font-display text-4xl uppercase">Page not found</h1>
    <Link to="/" className="btn-red mt-8 inline-flex">Home</Link>
  </div>;
  if (!page) return <div className="pt-40 text-center text-zinc-500">Loading…</div>;
  return (
    <>
      <PageHeader eyebrow="Policy" title={page.title} back />
      <div className="max-w-[800px] mx-auto px-4 sm:px-6 py-12 prose prose-invert">
        <div className="text-zinc-300 leading-relaxed" dangerouslySetInnerHTML={{ __html: sanitizeHtml(page.content) }}/>
      </div>
    </>
  );
}
